<template>
  <div>
    <the-header :contract="contract"/>
    <contract-bar :contract="contract" v-if="contract"/>
    <router-view @actioned="actioned" v-if="contract"/>
    <div class="d-flex justify-content-center" v-if="modalConfig.show">
      <blank-document/>
    </div>
    <modal v-if="modalConfig.show"
           :width="modalConfig.width"
           :disableHeader="true"
           :disableFooter="true">
      <template #body>
        <result-information :modalConfig="modalConfig"/>
      </template>
    </modal>
  </div>
</template>

<script>
import ContractServices from '@/modules/contract/services/contract.services';
import ContactMixins from '@/modules/common/mixins/contact.mixin';
import ActivityService from '@/modules/common/services/activity.service';

export default {
  name: 'Private',
  data() {
    return {
      modalConfig: {
        show: false,
        width: 350,
        type: false,
      },
    };
  },
  mixins: [ContactMixins],
  computed: {
    contract() {
      return this.$store.state.contract;
    },
    token() {
      return this.$store.state.token;
    },
  },
  created() {
    this.initController();
  },
  components: {
    TheHeader: () => import('../components/TheHeader.vue'),
    ContractBar: () => import('@/modules/contract/components/contract/ContractBar.vue'),
    Modal: () => import('@/modules/common/components/modal/Modal.vue'),
    BlankDocument: () => import('@/modules/validate_landing/components/BlankDocument.vue'),
    ResultInformation: () => import('@/modules/contract/components/contract/ResultInformation.vue'),
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    async init() {
      try {
        const contract = await new ContractServices().retrieve(this.$route.params.document_unique_key);
        await this.$store.dispatch('setContract', contract);
        setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 171), 0);
      } catch (e) {
        await this.preventEntering();
      }
    },
    destroy() {
      this.$store.dispatch('setContract', false);
      this.$store.dispatch('setToken', false);
    },
    initController() {
      if (!this.token) {
        this.preventEntering();
      } else {
        this.init();
      }
    },
    actioned(data) {
      this.destroy();
      this.modalConfig = {
        ...this.modalConfig,
        ...data,
      };
      this.modalConfig.show = true;
    },
  },
};
</script>
